import api from "@/api/api";
import {iniciarRequisicao, logout} from "@/helpers";
import {STATUS_HTTP} from "../../statusHTTP";

const PREFIXO = 'diagnostico/slow-no-moving/indicadores/movimentacao-estoque';

export const buscarStatusMovimentacao = async (params) => {
  const url = `/${PREFIXO}/status`;
  const {data, status} = await api.get(url, {params, headers: iniciarRequisicao()}).catch(logout);

  if (status !== STATUS_HTTP.OK) {
    logout();
  }

  localStorage.token = data.token;
  return data;
}

export const buscarSegmentos = async (params) => {
  const url = `/${PREFIXO}/status/segmentos`;
  const {data, status} = await api.get(url, {params, headers: iniciarRequisicao()}).catch(logout);

  if (status !== STATUS_HTTP.OK) {
    logout();
  }

  localStorage.token = data.token;
  return data.itens;
}

export const buscarFornecedores = async (params) => {
  const url = `/${PREFIXO}/status/segmentos/fornecedores`;
  const {data, status} = await api.get(url, {params, headers: iniciarRequisicao()}).catch(logout);

  if (status !== STATUS_HTTP.OK) {
    logout();
  }

  localStorage.token = data.token;
  return data.itens;
}

export const buscarProdutos = async (params) => {
  const url = `/${PREFIXO}/status/segmentos/fornecedores/produtos`;
  const {data, status} = await api.get(url, {params, headers: iniciarRequisicao()}).catch(logout);

  if (status !== STATUS_HTTP.OK) {
    logout();
  }

  localStorage.token = data.token;
  return data.itens;
}

export const buscarProdutosDetalhamento = async (params) => {
  const url = `/${PREFIXO}/status/produtos`;
  const {data, status} = await api.get(url, {params, headers: iniciarRequisicao()}).catch(logout);

  if (status !== STATUS_HTTP.OK) {
    logout();
  }

  localStorage.token = data.token;
  return data.produtos;
}
